import { render, staticRenderFns } from "./manage-gateway.vue?vue&type=template&id=47918427"
import script from "./manage-gateway.vue?vue&type=script&lang=js"
export * from "./manage-gateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports